<template>
  <b-table class="mh-125" responsive :items="items" :fields="fieldsTable" :fixed="true">
    <template #cell(name)="{ item }">
      <p>
        {{ item.name ?? '' }}
      </p>
    </template>
    <template #cell(serial)="{ item }">
      <p>
        {{ item.serialNumber ?? '' }}
      </p>
    </template>
    <template #cell(priceRenewalSim)="{ item }">
      <p class="text-right">
        {{ item.price ?? 0 | fomatCurrency }}
      </p>
    </template>
  </b-table>
</template>
<script>
  export default {
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        fieldsTable: [
          { key: 'name', label: 'Tên' },
          {
            key: 'serial',
            label: 'Mã serial',
          },
          {
            key: 'priceRenewalSim',
            label: 'Giá gia hạn sim',
            tdClass: 'text-right',
            thClass: 'text-right',
          },
        ],
      }
    },
  }
</script>
